import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#CE0000" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink target="_blank" href="https://www.facebook.com/dolpanbbq/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Dolpan Seoul BBQ Facebook"
              />
            </CFLink>
            <CFLink
              target="_blank"
              href="https://www.instagram.com/dolpanbbq/?hl=en"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Dolpan Seoul BBQ Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#CE0000" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink target="_blank" href="https://www.facebook.com/dolpanbbq/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Dolpan Seoul BBQ Facebook"
                hover
              />
            </CFLink>
            <CFLink
              target="_blank"
              href="https://www.instagram.com/dolpanbbq/?hl=en"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Dolpan Seoul BBQ Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
